import React from 'react';
import clsx from 'clsx';

interface ReusableModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  maxWidth?: string;
  hideFooter?: boolean;
  footerContent?: React.ReactNode; // para reemplazar el botón por defecto
}

const ReusableModalWrapper: React.FC<ReusableModalWrapperProps> = ({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'max-w-4xl',
  hideFooter = false,
  footerContent,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed left-0 top-0 z-[99999] flex h-screen w-full justify-center overflow-y-auto bg-black/80 px-4 py-5">
      <div
        className={clsx(
          'relative m-auto w-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-meta-4',
          maxWidth
        )}
      >
        {/* Encabezado */}
        <div className="flex items-center justify-between border-b border-stroke px-4 py-4 sm:px-8 sm:py-6">
          <h2 className="text-gray-900 text-base font-semibold dark:text-white">
            {title}
          </h2>
          <button onClick={onClose}>
            <svg
              className="text-gray-500 hover:text-gray-700 dark:text-gray-300 fill-current dark:hover:text-white"
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.8913 9.99599L19.5043 2.38635C20.032 1.85888 20.032 1.02306 19.5043 0.495589C18.9768 -0.0317329 18.141 -0.0317329 17.6135 0.495589L10.0001 8.10559L2.38673 0.495589C1.85917 -0.0317329 1.02343 -0.0317329 0.495873 0.495589C-0.0318274 1.02306 -0.0318274 1.85888 0.495873 2.38635L8.10887 9.99599L0.495873 17.6056C-0.0318274 18.1331 -0.0318274 18.9689 0.495873 19.4964C0.717307 19.7177 1.05898 19.9001 1.4413 19.9001C1.75372 19.9001 2.13282 19.7971 2.40606 19.4771L10.0001 11.8864L17.6135 19.4964C17.8349 19.7177 18.1766 19.9001 18.5589 19.9001C18.8724 19.9001 19.2531 19.7964 19.5265 19.4737C20.0319 18.9452 20.0245 18.1256 19.5043 17.6056L11.8913 9.99599Z"
              />
            </svg>
          </button>
        </div>

        {/* Contenido */}
        <div className="space-y-4 px-4 py-3 sm:px-6 sm:py-4 bg-whiter dark:bg-meta-4">
          {children}
        </div>

        {/* Pie */}
        {!hideFooter && (
          <div className="flex justify-end border-t border-stroke px-4 py-4 sm:px-8 sm:py-5">
            {footerContent ? (
              footerContent
            ) : (
              <button
                onClick={onClose}
                className="rounded bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-opacity-90"
              >
                Cerrar
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReusableModalWrapper;
